/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { action, observable } from 'mobx';

class Banners {
    @observable banners = [];

    @observable bannerLoadingStatus = {};

    @action
    addBanner(banner) {
        this.banners.push(banner);
    }

    @action
    setBannerLoaded(appSectionFilter) {
        this.bannerLoadingStatus[appSectionFilter] = true;
    }

    @action
    addBanners(banners) {
        this.banners = [...this.banners, ...banners];
    }

    @action
    removeBanner(banner) {
        return this.banners.remove(banner);
    }

    @action
    clear() {
        return this.banners.clear();
    }

    filterBanners(filters = {}, exclude = false) {
        const filteredBanners = this.banners.filter((banner) => {
            let include = true;
            Object.keys(filters).forEach((filterKey) => {
                if (!filters[filterKey]) {
                    return;
                }
                const bannerFilterValue = banner[filterKey];
                if (bannerFilterValue) {
                    if (typeof bannerFilterValue === 'string') {
                        include = include && bannerFilterValue === filters[filterKey];
                    } else if (Array.isArray(bannerFilterValue.slice())) {
                        include = include && bannerFilterValue.includes(filters[filterKey]);
                    }
                }
            });
            return exclude ? !include : include;
        });
        return filteredBanners;
    }

    hasBannerLoaded(appSectionFilter = []) {
        if (!appSectionFilter.length) {
            return false;
        }
        const appSectionFilterValue = Array.isArray(appSectionFilter)
            ? appSectionFilter[0] : appSectionFilter;
        return this.bannerLoadingStatus[appSectionFilterValue === 'all' ? 'all' : 'category'];
    }
}

export default new Banners();
